// tslint:disable:no-var-requires

export const ChevronDown = require("./files/chevron-down.svg");
export const Close = require("./files/close.svg");
export const FavLogoBlack = require("./files/logo.svg");
export const Check = require("./files/check.svg");
export const DobleCheck = require("./files/doble-check.svg");
export const Info = require("./files/info.svg");
